import React, { useState } from "react";
import { useApp } from "../context/AppContext";
import { useNavigate, Link } from "react-router-dom";
import toast from "react-hot-toast";

const ProductCard = ({ product }) => {
  const { addToCart, cart, updateCartQuantity } = useApp();
  const navigate = useNavigate();
  const [imgError, setImgError] = useState(false);

  const cartItem = cart.find((item) => item.productId === product._id);
  const quantity = cartItem?.quantity || 0;
  const discount = product.originalPrice
    ? Math.round(
        ((product.originalPrice - product.price) / product.originalPrice) * 100,
      )
    : 0;

  const handleAdd = () => {
    addToCart(product, 1);
    toast.success(`${product.name} added! 🛒`);
  };

  const fallback = `https://via.placeholder.com/400x400/e8f5e9/2D8B4E?text=${encodeURIComponent(product.name)}`;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        background: "#fff",
        borderRadius: 10,
        border: "1px solid #efefef",
        boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
        overflow: "hidden",
        transition: "transform 0.16s ease, box-shadow 0.16s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-2px)";
        e.currentTarget.style.boxShadow = "0 5px 16px rgba(45,139,78,0.11)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "none";
        e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.06)";
      }}
    >
      {/* ── IMAGE — strict square, max 55% of card ── */}
      <div
        onClick={() => navigate(`/products/${product._id}`)}
        style={{
          position: "relative",
          width: "100%",
          paddingTop:
            "72%" /* 72% of width → slightly shorter than square, feels compact */,
          overflow: "hidden",
          background: "#f5f5f5",
          flexShrink: 0,
          cursor: "pointer",
        }}
      >
        {/* badges */}
        <div
          style={{
            position: "absolute",
            top: 5,
            left: 0,
            right: 0,
            zIndex: 2,
            display: "flex",
            justifyContent: "space-between",
            padding: "0 5px",
            pointerEvents: "none",
          }}
        >
          {product.isBestseller ? (
            <span
              style={{
                padding: "2px 6px",
                fontSize: 7,
                fontWeight: 900,
                background: "linear-gradient(90deg,#c2410c,#ea580c)",
                color: "#fff",
                borderRadius: "0 4px 4px 0",
                letterSpacing: "0.4px",
                textTransform: "uppercase",
              }}
            >
              ⚡ Best
            </span>
          ) : (
            <span />
          )}
          {discount > 0 && (
            <span
              style={{
                padding: "2px 5px",
                fontSize: 7,
                fontWeight: 900,
                background: "#16a34a",
                color: "#fff",
                borderRadius: 4,
              }}
            >
              {discount}% OFF
            </span>
          )}
        </div>

        <img
          src={imgError ? fallback : product.image}
          alt={product.name}
          onError={() => setImgError(true)}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block",
            transition: "transform 0.3s ease",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.transform = "scale(1.05)")
          }
          onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
        />

        {/* rating */}
        <div
          style={{
            position: "absolute",
            bottom: 5,
            right: 5,
            background: "rgba(255,255,255,0.9)",
            backdropFilter: "blur(4px)",
            borderRadius: 20,
            padding: "2px 5px",
            display: "flex",
            alignItems: "center",
            gap: 2,
            border: "1px solid rgba(0,0,0,0.06)",
          }}
        >
          <span style={{ color: "#f59e0b", fontSize: 8, lineHeight: 1 }}>
            ★
          </span>
          <span style={{ fontSize: 8, fontWeight: 800, color: "#374151" }}>
            {product.rating}
          </span>
        </div>
      </div>

      {/* ── INFO — tight ── */}
      <div
        style={{
          padding: "6px 8px 4px",
          flex: 1,
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <h3
          style={{
            margin: 0,
            fontSize: 11.5,
            fontWeight: 700,
            color: "#111827",
            lineHeight: 1.25,
            overflow: "hidden",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
          }}
        >
          <Link
            to={`/products/${product._id}`}
            style={{ textDecoration: "none", color: "inherit" }}
          >
            {product.name}
          </Link>
        </h3>

        {product.volume && (
          <span
            style={{
              display: "inline-block",
              padding: "1px 5px",
              border: "1px solid rgba(45,139,78,0.3)",
              color: "#2D8B4E",
              fontSize: 8.5,
              fontWeight: 700,
              borderRadius: 4,
              background: "rgba(45,139,78,0.05)",
              alignSelf: "flex-start",
            }}
          >
            {product.volume}
          </span>
        )}

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginTop: "auto",
            paddingTop: 2,
          }}
        >
          <div style={{ display: "flex", alignItems: "baseline", gap: 4 }}>
            <span
              style={{
                fontSize: 13.5,
                fontWeight: 900,
                color: "#15803d",
                letterSpacing: "-0.3px",
              }}
            >
              ₹{product.price}
            </span>
            {product.originalPrice && (
              <span
                style={{
                  fontSize: 9,
                  color: "#9ca3af",
                  textDecoration: "line-through",
                }}
              >
                ₹{product.originalPrice}
              </span>
            )}
          </div>
          <button
            onClick={(e) => {
              e.stopPropagation();
              navigate(`/products/${product._id}`);
            }}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              background: "none",
              border: "none",
              cursor: "pointer",
              color: "#2D8B4E",
              fontSize: 9.5,
              fontWeight: 700,
              padding: "2px 0",
              lineHeight: 1,
              textDecoration: "underline",
              textDecorationColor: "rgba(45,139,78,0.35)",
              textUnderlineOffset: "2px",
              flexShrink: 0,
            }}
          >
            Read more...
            <svg
              width="9"
              height="9"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>

      {/* ── ACTION ── */}
      <div style={{ padding: "0 7px 7px" }}>
        {quantity === 0 ? (
          <button
            onClick={handleAdd}
            style={{
              width: "100%",
              padding: "6px",
              background: "linear-gradient(135deg,#15803d,#22c55e)",
              color: "#fff",
              border: "none",
              borderRadius: 7,
              fontSize: 10.5,
              fontWeight: 700,
              cursor: "pointer",
              transition: "all 0.15s ease",
              boxShadow: "0 2px 7px rgba(21,128,61,0.28)",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-1px)";
              e.currentTarget.style.boxShadow =
                "0 4px 11px rgba(21,128,61,0.38)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "none";
              e.currentTarget.style.boxShadow =
                "0 2px 7px rgba(21,128,61,0.28)";
            }}
          >
            Add to Cart
          </button>
        ) : (
          <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                border: "1.5px solid #16a34a",
                borderRadius: 7,
                overflow: "hidden",
                flex: 1,
                background: "#f0fdf4",
              }}
            >
              <button
                onClick={() => updateCartQuantity(product._id, quantity - 1)}
                style={{
                  flex: 1,
                  background: "none",
                  border: "none",
                  color: "#16a34a",
                  fontSize: 15,
                  fontWeight: 700,
                  cursor: "pointer",
                  padding: "4px 0",
                  lineHeight: 1,
                }}
              >
                −
              </button>
              <span
                style={{
                  fontSize: 11,
                  fontWeight: 900,
                  color: "#15803d",
                  minWidth: 16,
                  textAlign: "center",
                }}
              >
                {quantity}
              </span>
              <button
                onClick={() => addToCart(product, 1)}
                style={{
                  flex: 1,
                  background: "none",
                  border: "none",
                  color: "#16a34a",
                  fontSize: 15,
                  fontWeight: 700,
                  cursor: "pointer",
                  padding: "4px 0",
                  lineHeight: 1,
                }}
              >
                +
              </button>
            </div>
            <button
              onClick={() => navigate("/cart")}
              style={{
                flex: 1,
                padding: "5px 3px",
                background: "#15803d",
                color: "#fff",
                border: "none",
                borderRadius: 7,
                fontSize: 9.5,
                fontWeight: 700,
                cursor: "pointer",
                whiteSpace: "nowrap",
                transition: "background 0.15s",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.background = "#166534")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.background = "#15803d")
              }
            >
              View Cart
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductCard;
